import {
  CustomTabList,
  SectionCard,
  SectionCardSubTitle,
  SectionCardTitle,
} from "@/components";
import { Tabs, TabsContent } from "@/components/ui";
import { tabs } from "./const";
import { Gallery } from "./Gallery";

const UpdatesInfo = () => {
  return (
    <section className="bg-[#F9F9F9]">
      <SectionCard className=" items-center justify-center">
        
        <Tabs defaultValue="1" className="mt-6 flex items-center">
          <CustomTabList tabs={tabs}/>
          
          <TabsContent value="1">    
                <Gallery />
          </TabsContent>
        </Tabs>
      </SectionCard>
    </section>
  );
};

export default UpdatesInfo;
